import React from 'react';

export const useFocusVisibleRef = (focusWithinList: React.MutableRefObject<any>[] = [], ref?: React.MutableRefObject<any> | null) => {
  const elementRef = ref ?? React.useRef<any>(null);
  const suppress = React.useRef<boolean>(false);
  const [visible, setVisible] = React.useState(false);

  const addFocusVisibleClasses = () => {
    elementRef.current?.classList.add('focus-visible');
    focusWithinList?.forEach((focusWithinListItem) => {
      focusWithinListItem.current?.classList.add('focus-visible-within');
    });
  }

  const removeFocusVisibleClasses = () => {
    elementRef.current?.classList.remove('focus-visible');
    focusWithinList?.forEach((focusWithinListItem) => {
      focusWithinListItem.current?.classList.remove('focus-visible-within');
    });
  }

  const handleMouseDown = () => {
    if (!elementRef.current?.classList.contains('focus-visible')) {
      suppress.current = true;
    }
  };

  const handleFocus = () => {
    if (!suppress.current) {
      setVisible(true);
      addFocusVisibleClasses();
    } else {
      suppress.current = false;
    }
  };

  const handleBlur = () => {
    setVisible(false);
    removeFocusVisibleClasses();
  };


  React.useLayoutEffect(() => {
    if (visible) {
      addFocusVisibleClasses()
    } else {
      removeFocusVisibleClasses();
    }
  }, [visible, elementRef, focusWithinList]);

  React.useEffect(() => {
    if (!elementRef.current) return;

    const instance = elementRef.current;
    const focusFn = elementRef.current.focus;
    elementRef.current.focus = (e: any) => {
      suppress.current = !e?.focusVisible;
      focusFn.call(instance, e);
    };

    instance.addEventListener('mousedown', handleMouseDown);
    instance.addEventListener('focus', handleFocus);
    instance.addEventListener('blur', handleBlur);

    return () => {
      instance.removeEventListener('mousedown', handleMouseDown);
      instance.removeEventListener('focus', handleFocus);
      instance.removeEventListener('blur', handleBlur);
      instance.classList.remove('focus-visible');
      for (let el of focusWithinList) {
        el.current?.classList.remove('focus-visible-within');
      }
    };
  }, [elementRef]);

  return elementRef;
};
